import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingColors } from 'helpers/constants';

const styles = makeStyles((theme) => ({
  subtitle: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '150%',
    color: '#192542',
  },
  inputValue: {
    marginBottom: '0 !important',
    '& > div': {
      paddingRight: 0,
    },
    '& input': {
      height: 'unset',
      fontSize: '22px !important',
      textAlign: 'center',
    },
    '& fieldset': {
      borderColor: '#B0BEC5',
    },
    '& .__message': {
      fontSize: 12,
      lineHeight: '150%',
      color: theme.palette.error.main,
      fontWeight: 700,
    },
  },
  clearValue: {
    fontSize: 16,
    color: '#B0BEC5',
    cursor: 'pointer',
  },
  valueAvailable: {
    margin: '16px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 16,
    lineHeight: '150%',
    color: theme.palette.grey[500],
    '& strong': {
      color: ERebrandingColors.MAIN,
    },
  },
  optionsDescription: {
    fontSize: 16,
    lineHeight: 1.5,
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionsList: {
    display: 'flex',
  },
  anticipationOption: {
    display: 'flex',
    width: '50%',
    marginTop: 16,
    fontSize: 14,
    lineHeight: 1.3,
    '& > span': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  alertList: {
    padding: '16px 0',
    borderTop: '#ECEFF1 thin solid',
    borderBottom: '#ECEFF1 thin solid',
  },
  alertItem: {
    boxShadow: 'none',
    fontSize: 12,
    color: theme.palette.grey[500],
    '& span': { display: 'block', color: theme.palette.grey[800] },
  },
  helpLink: {
    display: 'block',
    marginTop: '0.75rem',
    fontSize: 14,
    color: theme.palette.grey[500],
  },
  description: {
    fontSize: 12,
    lineHeight: '150%',
    color: theme.palette.grey[500],
    display: 'block',
    marginTop: 16,
    '& > a': { fontWeight: 'bold', color: theme.palette.grey[500] },
  },
  successMsg: {
    textAlign: 'center',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > img': {
      marginBottom: 24,
    },
    '& > strong': {
      paddingTop: 16,
    },
  },
  warning: {
    marginTop: 16,
    fontSize: 12,
  },
}));

export default styles;
